<template>
 <div class="container" v-if="isShow">
      <div class="mask"></div>
      <div class="box">
           <p class="tip1">是否收回垫付金</p>
           <p class="tip2">垫付金额¥{{ money }}</p>
           <!-- <p class="tip3">“已完成”状态</p> -->
           <div class="btn">
                <span class="left" @click="sell">取消</span>
                <span class="right" @click="confirm">已收回</span>
           </div>
      </div>
 </div>
</template>
<script>
    export default {
        props: ['money'],
        data () {
            return {
                isShow: false,
                isFlag: true
            }
        },
        created () {

        },
        methods: {
            showBox () {
                this.isShow = true;
            },
            confirm () { // 关注
                this.isShow = false;
                if (this.isFlag) {
                    this.$emit('sendRecover');
                    this.isFlag = false;
                }
            },
            sell () {
                this.isShow = false;
            }
        }
    }
</script>
<style lang="less" scoped>
.container{
    width:100%;
    height:100%;
    // position: absolute;
    // left:0;
    // top:0;
    // z-index: 20;
    // background-color: pink;
    .mask{
        width:100%;
        height:100%;
        position: fixed;
        left:0;
        top:0;
        z-index: 20;
        background: rgba(0,0,0,.5);
    }
    .box{
        position: fixed;
        width:260px;
        padding:40px 0 0 0;
        background: #fff;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        z-index: 30;
        text-align: center;
        border-radius: 6px;
        .tip1{
            font-size:18px;
            color:#000;
            // margin-top:30px;
        }
        .tip2{

            font-size:14px;
            color:#B7B7B7;
            margin-top:30px;
            margin-top:16px;
        }
        .tip3{

            font-size:14px;
            color:#B7B7B7;
            margin-top:30px;
            margin-top:12px;
        }
        .btn{
            width:100%;
            // padding:0 15px;
            display: flex;
            display: -webkit-flex;
            // justify-content: space-between;
            flex-direction: row;
            margin-top:40px;
            .left{
                flex: 1;
                // width:100px;
                height:40px;
                border:1px solid #CCCCCC;
                border-bottom: 0;
                text-align: center;
                line-height: 40px;
                font-size:15px;
                color:#CCCCCC;
            }
            .right{
                flex: 1;
                // width:100px;
                border-bottom: 0;
                height:40px;
                background: @base-color;
                color:#fff;
                text-align: center;
                line-height: 40px;
                font-size:15px;
            }
        }
    }
}
</style>
